import { render, staticRenderFns } from "./NewProjectModal.vue?vue&type=template&id=72a236ff&scoped=true"
import script from "./NewProjectModal.vue?vue&type=script&lang=ts"
export * from "./NewProjectModal.vue?vue&type=script&lang=ts"
import style0 from "./NewProjectModal.vue?vue&type=style&index=0&id=72a236ff&prod&lang=scss"
import style1 from "./NewProjectModal.vue?vue&type=style&index=1&id=72a236ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a236ff",
  null
  
)

export default component.exports